import { SANDO_WHATSAPP_NUMBER } from "@/mocks/site";

export function whatsappUrl(message: string): string {
  return `https://wa.me/${SANDO_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}